/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['underscore',
	'./ConversionService'
], function(_, ConversionService) {
	const conversionServiceInstance = new ConversionService();
	const ConverterInterface = conversionServiceInstance.getInterface();

	class DashboardToStoryConverter extends ConverterInterface {
		constructor(definition) {
			super(Object.assign({
				src: 'DASHBOARD',
				target: 'STORY'
			}, definition));
		}

		convert(src, target, spec) {
			// no conversion needed at this time.
			return Promise.resolve(spec);
		}

		validate(spec) {
			return !!spec;
		}
	}
	return DashboardToStoryConverter;
});
